import React, { useState } from "react";
import { motion } from "framer-motion";
import { CloseButtonProps } from "./CloseButton.types";

import "./CloseButton.scss";

const CloseButton: React.FC<CloseButtonProps> = ({ handleClose, dark }) => {
  const [animate, setAnimate] = useState("init");
  const [mouseDown, setMouseDown] = useState(false);

  return (
    <div className="mp-atoms-closebutton--main">
      <motion.div
        onClick={() => {
          handleClose();
        }}
        className="close-button"
        data-testid="close-button"
        onMouseOver={() => setAnimate("over")}
        onMouseOut={() => {
          setAnimate("init");
        }}
        onMouseDown={() => {
          setMouseDown(true);
          setAnimate("down");
        }}
        onMouseUp={() => {
          setMouseDown(false);
          setAnimate("up");
        }}
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
          transition: { delay: 0.25 },
        }}
        exit={{
          opacity: 0,
        }}
      >
        <motion.div
          className={`close-button-line ${dark && "dark"}`}
          animate={animate}
          variants={{
            init: { rotate: -45 },
            over: { rotate: 0 },
            down: { width: "0.5em", left: "0.75em" },
            up: { width: "1em" },
          }}
        />
        <motion.div
          className={`close-button-line ${dark && "dark"}`}
          animate={animate}
          variants={{
            init: { rotate: 45 },
            over: { rotate: 0 },
            down: { width: "0.5em", left: "0.75em" },
            up: { width: "1em" },
          }}
        />
      </motion.div>
    </div>
  );
};

export default CloseButton;
